// extracted by mini-css-extract-plugin
export default {"overlay":"Popup_overlay__prz3q","popup":"Popup_popup__C5HH2","tooltipPopup":"Popup_tooltipPopup__E-9EW","fadeIn":"Popup_fadeIn__XS2is"};